import list from './list'

const conceptualObjects =
{
    ...list,
    helmet :
    {
        title : 'Objets' ,
        metas : []
    },
    empty  : 'Aucun objet trouvé',
    search : 'Rechercher un objet ...' ,
    title  : 'Objets'
};

export default conceptualObjects ;
